import React, { useState, useEffect, useRef } from "react";
import Button from "@atlaskit/button";
import Spinner from "@atlaskit/spinner";
import Lozenge from "@atlaskit/lozenge";
import Tooltip from "@atlaskit/tooltip";
import { useNavigate } from "react-router-dom";
import Form, {
  CheckboxField,
  Field,
  FormFooter,
  FormSection,
  ErrorMessage,
} from "@atlaskit/form";
import { Checkbox } from "@atlaskit/checkbox";
import Textfield from "@atlaskit/textfield";
import TextArea from "@atlaskit/textarea";
import { API } from "../../utility/Api";
import styles from "./Backup.module.css";
import { UseToast } from "../../components/context/ToastContext";

import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
const Backup = (props) => {
  const navigate = useNavigate();
  const { setMainMessage } = UseToast();
  // const [isError, setError] = useState("");
  // const [isMessage, setMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [formStateData, setFormStateData] = useState({
    isIssueChecked: true,
    isConfigChecked: true,
    tag: "",
  });
  const [showConfirmation, setShowConfirmation] = useState(false);

  const validate = useRef("");

  // useEffect(() => {
  //   // Get issues, screens , workflows, for current tenant
  //   const getScreenCount = async (token) => {
  //     // eslint-disable-next-line no-undef
  //     await AP.request("/rest/api/3/screens?maxResults=0", {
  //       success: function (responseText) {
  //         const data = JSON.parse(responseText);
  //         settotalScreenCount(data.total);
  //       },
  //     });
  //   };
  //   const getWorkflowCount = async (token) => {
  //     // eslint-disable-next-line no-undef
  //     await AP.request("/rest/api/3/workflow/search?maxResults=0", {
  //       success: function (responseText) {
  //         const data = JSON.parse(responseText);
  //         settotalWorkflowCount(data.total);
  //       },
  //     });
  //   };
  //   const getIssueCount = async (token) => {
  //     // eslint-disable-next-line no-undef
  //     await AP.request("/rest/api/3/search?maxResults=0", {
  //       success: function (responseText) {
  //         const data = JSON.parse(responseText);
  //         setTotalIssueCount(data.total);
  //       },
  //     });
  //   };
  //   // eslint-disable-next-line
  //   AP.context.getToken(function (token) {
  //     getScreenCount(token);
  //     getWorkflowCount(token);
  //     getIssueCount(token);
  //   });
  // }, []);

  const getData = () => {
    const fieldsToBackup =
      formStateData.isIssueChecked && formStateData.isConfigChecked
        ? 0
        : formStateData.isIssueChecked
        ? 1
        : formStateData.isConfigChecked
        ? 2
        : 3;
    const backupTag = formStateData.tag ? `&tag=${formStateData.tag}` : "";
    const queryParams = `backupType=${fieldsToBackup}${backupTag}`;
    // setMessage("");
    setMainMessage("");
    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      API.get(`/api/initiate_backup?${queryParams}`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setMainMessage("");
          setLoading(false);
          // setMessage("");
          setMainMessage("");

          if (
            response.status === 200 &&
            response.data.backupTriggered === true
          ) {
            // props.setSelected(1);
            // props.setShowComp("jobs")
            navigate("/backup/jobs");
            setMainMessage({
              text: "Backup job(s) initiated successfully",
              appearance: "success",
            });
            // setMessage({
            //   text: "Backup job triggered successfully",
            //   appearance: "success",
            // });
          } else if (
            response.status === 200 &&
            response.data.backupTriggered === false
          ) {
            // props.setSelected(1);
            navigate("/backup/jobs");
            setMainMessage({
              text: "Backup job is already running",
              appearance: "info",
            });
            // setMessage({
            //   text: "Backup job is already running",
            //   appearance: "info",
            // });
          }
        })
        .catch(function (error) {
          setMainMessage({ text: error.message, appearance: "error" });
          setLoading(false);
          setFormStateData({
            isIssueChecked: true,
            isConfigChecked: true,
            tag: "",
          });
        });
    });
  };

  useEffect(() => {
    setFormStateData({
      isIssueChecked: true,
      isConfigChecked: true,
      tag: "",
    });
  }, [props.selected]);
  const HandleOnKeydown = (e) => {
    e.key === "Enter" && setShowConfirmation(true);
  };

  return (
    <div className={styles.container}>
      <Form isDisabled={props.isLoading}>
        {({ formProps }) => (
          <form {...formProps}>
            <div className={styles.centerform}>
              <div className={styles.bottomborder}>
                <h2>
                  <strong>On-demand backup</strong>
                </h2>
                <p>
                  Initiate backup manually for issues / configurations. This
                  action will queue a backup job for the selected options.
                </p>
              </div>

              <FormSection>
                <div className={styles.formContainer}>
                  <div className={styles.horizaligncheck}>
                    <div className={styles.verticalsection}>
                      <CheckboxField name="issues">
                        {({ fieldProps }) => (
                          <Checkbox
                            {...fieldProps}
                            isChecked={formStateData.isIssueChecked}
                            onChange={() => {
                              setFormStateData({
                                ...formStateData,
                                isIssueChecked: !formStateData.isIssueChecked,
                              });
                            }}
                            label="Issues"
                            value="Issues"
                            name="issues"
                          />
                        )}
                      </CheckboxField>
                      <div className={styles.backuptypetextarea}>
                        <TextArea
                          minimumRows="8"
                          resize="auto"
                          maxHeight="100%"
                          name="area"
                          defaultValue="Issues &#13;&#10;Attachments &#13;&#10;Comments &#13;&#10;Link&#13;&#10;Votes &#13;&#10;Worklogs &#13;&#10;"
                          isReadOnly
                          isDisabled={!formStateData.isIssueChecked}
                        />
                      </div>
                      {/* <div className={styles.backupOptionInfo}>
                        <p className={styles.alignCenter}>
                          Total Issue Count :{" "}
                          <Lozenge isBold>{totalIssueCount}</Lozenge>
                        </p>
                      </div> */}
                    </div>
                    <div className={styles.verticalline}></div>
                    <div className={styles.verticalsection}>
                      <CheckboxField name="config">
                        {({ fieldProps }) => (
                          <Checkbox
                            {...fieldProps}
                            isChecked={formStateData.isConfigChecked}
                            onChange={() => {
                              setFormStateData({
                                ...formStateData,
                                isConfigChecked: !formStateData.isConfigChecked,
                              });
                            }}
                            label="Configurations"
                            value="Configuration"
                            name="configuration"
                          />
                        )}
                      </CheckboxField>
                      <div className={styles.backuptypetextarea}>
                        <TextArea
                          resize="auto"
                          minimumRows="8"
                          maxHeight="20vh"
                          name="area"
                          defaultValue="Screens &#13;&#10;Screen tab  &#13;&#10;Screen tabs fields&#13;&#10;Workflows&#13;&#10;Workflow transition rules&#13;&#10;Workflow transition properties &#13;&#10;Filters &#13;&#10;Issue link types &#13;&#10;Issue types &#13;&#10;Project Categories &#13;&#10;"
                          isReadOnly
                          isDisabled={!formStateData.isConfigChecked}
                        />
                      </div>
                      {/* <div className={styles.backupOptionInfo}>
                        <p className={styles.alignCenter}>
                          Screens Count :
                          <Lozenge isBold>{totalScreenCount}</Lozenge>{" "}
                        </p>
                        <p className={styles.alignCenter}>
                          Workflows Count :
                          <Lozenge isBold>{totalWorkflowCount}</Lozenge>{" "}
                        </p>
                      </div> */}
                    </div>
                  </div>

                  <div className={styles.horizaligncenter}>
                    <Field
                      name="tag"
                      defaultValue={formStateData.tag}
                      // validate={async (value) => {
                      //   const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                      //   if (value.length > 16) {
                      //     return "Max 16 characters";
                      //   } else {
                      //     if (regexp.test(value)) {
                      //       return undefined;
                      //     } else {
                      //       return "Please Enter Valid Text";
                      //     }
                      //   }
                      // }}
                    >
                      {({ fieldProps, error }) => (
                        <>
                          <Textfield
                            placeholder="Enter tag for backup snapshot"
                            width="350"
                            maxLength={16}
                            {...fieldProps}
                            onKeyDown={(e) => HandleOnKeydown(e)}
                            onChange={(value) => {
                              setFormStateData({
                                ...formStateData,
                                tag: value.target.value,
                              });
                              fieldProps.onChange(value);
                              const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");

                              if (regexp.test(value.target.value)) {
                                validate.current = "";
                              } else {
                                validate.current = "error";
                              }
                            }}
                          />

                          {error ? (
                            <ErrorMessage>{error}</ErrorMessage>
                          ) : validate.current === "error" ? (
                            <ErrorMessage>
                              Please enter a valid text
                            </ErrorMessage>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </Field>
                  </div>
                </div>
              </FormSection>
              <FormFooter className="footer">
                <Button
                  onClick={() => setShowConfirmation(true)}
                  shouldFitContainer
                  appearance="primary"
                  isDisabled={
                    !formStateData.isIssueChecked &&
                    !formStateData.isConfigChecked
                  }
                  style={{ marginTop: "10px", alignItems: "flex-start" }}
                >
                  Backup now
                </Button>
                <ModalTransition>
                  {showConfirmation && (
                    <Modal onClose={() => setShowConfirmation(false)}>
                      <ModalHeader>
                        <ModalTitle>
                          On-demand backup
                          {isLoading && <Spinner size="small" />}
                        </ModalTitle>
                      </ModalHeader>
                      <ModalBody>
                        Backup now will initiate a new backup and may take some
                        time to finish. <br />
                        <br />
                        Are you sure you want to proceed ?
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          appearance="subtle"
                          onClick={() => setShowConfirmation(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          onClick={() => {
                            getData();
                            setShowConfirmation(false);
                          }}
                          appearance="primary"
                          autoFocus
                        >
                          Backup Now
                        </Button>
                      </ModalFooter>
                    </Modal>
                  )}
                </ModalTransition>
              </FormFooter>
              <div className={styles.spinnercontainer}>
                {isLoading && <Spinner size="large" />}
              </div>
            </div>
          </form>
        )}
      </Form>
      {/* {isError ? (
        <div>
          <FlagError setFlag={[1]} message={isError} />
        </div>
      ) : (
        ""
      )} */}
      {/* {isMessage ? (
        <div>
          <FlagError setFlag={[1]} message={isMessage} />
        </div>
      ) : (
        ""
      )} */}
      {/* {isLoading ? (
        <div className={styles.spinner}>
          <Spinner size="large" />
        </div>
      ) : (
        ""
      )} */}
    </div>
  );
};

export default Backup;
